export default __webpack_public_path__ + "static/20922-Menu-PA-200-8df525f0b3d26e32e45582f94d69db1f.jpg";